export const user = (state) => state.user;
export const options = (state) => state.options;
export const ipAddr = (state) => state.ipAddr;
export const signup = (state) => state.signup;
export const userActions = (state) => state.userActions;
export const passwordReset = (state) => state.passwordReset;
export const deal = (state) => state.deal;
export const deals = (state) => state.deals;
export const createDeal = (state) => state.createDeal;
export const editDeal = (state) => state.editDeal;
export const deleteDeal = (state) => state.deleteDeal;
export const allDeals = (state) => state.allDeals;
export const investForm = (state) => state.investForm;
export const sendDetails = (state) => state.sendDetails;
export const cancelInvestment = (state) => state.cancelInvestment;
